// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1UUNK","title":"ClientCherryInfo_title__2FgHJ","itemText":"ClientCherryInfo_itemText__3A0go"};